import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const SecuritiesTransactionTax = () => {
  return (
    <>
      <TopBanner content={"Securities Transaction Tax"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>A Small Tax on Big Market Moves</h2>
          <p>
            Securities Transaction Tax (STT) is a tax levied when you buy or
            sell stocks, mutual funds, or other securities on recognized stock
            exchanges in India.
          </p>

          <p>
            It’s automatically added during online trading, so you don’t need to
            file it separately.
          </p>
          <h3>Key Points:</h3>
          <ul>
            <li>
              Applicable to shares, equity mutual funds, derivatives, etc.
            </li>
            <li>Charged at the time of each trade buy or sell</li>
            <li>Rates differ for delivery-based and intraday trading</li>
            <li>Helps regulate market transparency</li>
          </ul>
          <p>
            Whether you’re a casual investor or a frequent trader, STT is a part
            of every market move.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default SecuritiesTransactionTax;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
